import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import B2becTable from '@/components/B2becTable'
import { useAppDispatch, useAppSelector } from '@/store/hook'
import { selectHideListPriceGlobal } from '@/store/selectors/configSelector'
import { addProductToCart } from '@/store/slices/cartSlice'
import { useDeviceDetect } from '@/hooks'
import useDummyItems from '@/hooks/useDummyItems'
import usePermission from '@/hooks/usePermission'
import { MODULE_SHOP_NAVIGATION_RIGHTS } from '@/libs/constants/modulerights'
import { linkGenerator } from '@/libs/utils/language'

import tableColumns from './TableColumns'

const ProductCardTable = (props) => {
  const {
    dataSrc,
    isLoading = false,
    onCompareHandler,
    comparingProductIds,
  } = props
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { isIpadLandscape } = useDeviceDetect()
  const shouldHideListPriceGlobally = useAppSelector(selectHideListPriceGlobal)
  const {
    verifiedPermissions: [
      hasAddProductToCartPermission,
      hasProductComparisonPermission,
    ],
  } = usePermission([
    MODULE_SHOP_NAVIGATION_RIGHTS.ADD_PRODUCT_TO_SHOPPING_CART,
    MODULE_SHOP_NAVIGATION_RIGHTS.PRODUCT_COMPARISION,
  ])

  const shapeOfProduct = {
    pictureUrl: '',
    materialNumber: '',
    materialName: '',
    categoryName: '',
    listPrice: 0,
  }

  const fakeItems = useDummyItems(6, shapeOfProduct)
  const handleCellClick = (materialNumber) => {
    return navigate(linkGenerator(`/product/${materialNumber}`))
  }
  const addToCartHandler = (materialNumber) => {
    dispatch(addProductToCart({ materialNumber }))
  }

  const onCheckHandler = useCallback(
    (product, event) => {
      const isChecked = event?.target?.checked

      onCompareHandler(isChecked, product)
    },
    [onCompareHandler],
  )

  const renderColumns = () => {
    const currentTableColumns = tableColumns(
      addToCartHandler,
      handleCellClick,
      isLoading,
      onCheckHandler,
      comparingProductIds,
      hasAddProductToCartPermission,
      hasProductComparisonPermission,
      shouldHideListPriceGlobally,
    )
    // Don't render the column of comparison feature in mobile view
    return isIpadLandscape
      ? currentTableColumns.filter(
        (column) => column?.dataIndex !== 'comparison',
      )
      : currentTableColumns
  }

  return (
    <B2becTable
      style={{ marginTop: 20 }}
      className="order-details-cart-table"
      columns={renderColumns()}
      dataSource={isLoading ? fakeItems : dataSrc}
      pagination={false}
      rowKey="materialNumber"
    />
  )
}

export default ProductCardTable
